import React from 'react';

import styles from './CreateCalculationModal.scss';

export const BasicCalculationIcon = (props) => (
  <svg className={styles.cardIcon} viewBox="0 0 32 32" {...props}>
    <path d="M0,0V32H32V0ZM10.72,27,8.5,24.77,6.28,27,5,25.68l2.2-2.21L5,21.29,6.28,20l2.21,2.2L10.67,20,12,21.29,9.81,23.47,12,25.66ZM12.09,9.58H9.4v2.8H7.61V9.58H4.92V7.8H7.61V5H9.4V7.8h2.69ZM24.35,27H22.46V25.33h1.89ZM27,24.32H19.83V22.55H27Zm-4.54-2.76V19.9h1.89v1.66ZM27,9.76H19V7.87h8Z" />
  </svg>
);
